<template>
  <div id='myApp' class='gPageBorder' v-loading='loading'>

    <el-dialog  :title="dialogConfig.tip" :visible.sync="dialogTopMgVisible" style='text-align:center' size=tiny>
      <el-button style='width:20%;' @click='processRecommend(0)'>{{$t('app_no')}}</el-button>
      <el-button type='primary' style='margin-left:20%;width:20%;' @click='processRecommend(1)'>{{$t('app_yes')}}</el-button>
    </el-dialog>

    <el-row>
      <el-col :span='12'>
        <div class='gSgLeftBtn'>
        <el-button  type="primary" @click="add">{{$t('app_addsrc')}}</el-button>
       
        <el-button type="danger" :disabled="multipleSelection.length == 0" @click='bcdel' >{{$t('app_mulDel')}}</el-button>
        </div>
      </el-col>


      <el-col :span='4'>
        <div class='gCtrl'><MechanismSelector style='width:100%;' :data="mechanismData"></MechanismSelector></div>
      </el-col>

      <el-col :span='4' >

        <div class='gCtrl'>
          <el-select v-model="statusVl"  @change="stchange" placeholder="">
            <el-option
              v-for="item in sstatusAr"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </el-col>

      <el-col :offset="0" :span='4'>
        <div class='gSideCtrl'><el-input  :placeholder="$t('app_name') + '&' + $t('app_number') " icon='search' :on-icon-click='query' @keyup.enter.native='query' v-model='queryKey'></el-input></div>
      </el-col>
    </el-row>
    

  
    <div >
      <el-table
      class='tbPoint gTopMg'
      @row-click='cellClick'
	    ref="multipleTable"
	    :data="tableData"
	    border
	    tooltip-effect="dark"
	    style="width: 100%"
	    @selection-change="handleSelectionChange">
  	    <el-table-column
          align=center
  	      type="selection"
  	      width="55">
  	    </el-table-column>
  	    <el-table-column
          align=center
  	      prop='name'
  	      :label="$t('app_srcname')"
  	      width="">
  	    </el-table-column>
  	    <el-table-column
          align=center
  	      prop='mechanismName'
  	      :label="$t('app_distributor')"
  	      width="">
  	    </el-table-column>
        <el-table-column
          align=center
  	      prop='version'
  	      :label="$t('app_newgVer')"
  	      width="">
  	    </el-table-column>
        <el-table-column
          header-align='center'
          align='center'
          prop="status"
          width='115'
          :label="$t('app_vStatus')">
          <template slot-scope='scope'>
            <el-label :style='getStatus(scope.row.status).style'>{{getStatus(scope.row.status).vl}}</el-label>
          </template>
        </el-table-column>
  	    <!-- <el-table-column
          align=center
  	      prop="appInstallType"
  	      :label="$t('app_insType')"
  	      width='100'>
          <template slot-scope='scope'>
            <el-label>{{setInstallType(scope.row.appInstallType)}}</el-label>
          </template>
  	    </el-table-column> -->
  	  
        <el-table-column
          align=center
  	      prop='createTime'
          width='116'
  	      :label="$t('app_adddate')"
  	    >
  	    </el-table-column>
  	    <el-table-column
  	      prop="operate"
          align=left
  	      :label="$t('app_operate')"
  	      width='136'>
  	      <template slot-scope='scope'>
            <!-- <el-button @click='edit(scope.row)' type=text>编辑</el-button> -->

            <el-tooltip class="item"  effect="dark" :content="$t('app_del')" placement="top" >
              <el-button type='text'   @click='del(scope.row.id)'><i class="fa fa-trash-o" style="color:#FF4949"></i></el-button>
            </el-tooltip>

            <el-tooltip class="item" effect="dark" :content="$t('app_edit')" placement="top" v-show="scope.row.status != '1' && scope.row.status != '2' ">
              <el-button type='text'  @click='edit(scope.row)'><i class="fa fa-pencil-square" style=""></i></el-button>
            </el-tooltip>

            <el-tooltip v-show="scope.row.status == '0' || scope.row.status == '3' " class="item" effect="dark" :content="$t('app_smVerify')" placement="top">
              <el-button type='text'  @click='submit(scope.row.id)'><i class="fa fa-external-link-square" style=""></i></el-button>
            </el-tooltip>

            <!-- <el-tooltip v-show="scope.row.status == '2'" class="item" effect="dark" :content="$t('app_addPush')" placement="top">
              <el-button type='text'  @click='push(scope.row)'><i class="fa fa-upload" style=""></i></el-button>
            </el-tooltip> -->


            <!-- <el-button @click='del(scope.row.dispenserId)' type=text>{{$t('app_addtask')}}</el-button> -->

  	        <!-- <el-button @click='undercarriage(scope.row)' type=text>{{$t('app_offShelf')}}</el-button> -->

            <!-- <el-tooltip class="item" effect="dark" :content="$t('app_push')" placement="top">
              <el-button type='text' @click='bindOperate(scope.row)'><i class="fa fa-upload" style=""></i></el-button>
            </el-tooltip> -->

            <!-- <el-tooltip class="item" effect="dark" :content="$t('app_offShelf')" placement="top">
              <el-button type='text' @click='undercarriage(scope.row)'><i class="fa fa-arrow-circle-o-down" style=""></i></el-button>
            </el-tooltip> -->

  	      </template>
  	    </el-table-column>
  	  </el-table>
    </div>
    
    <div class="gPgDiv" >

      <el-pagination
        class='gPg'
        @current-change="pageSelect"
        @size-change="pageSized"
        :current-page="page"
        :page-sizes='$gRows'
        :page-size="row"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
    </div>
  </div>
</template>

<style>
  html body{background:white;margin:0;padding:0}
  #myApp{background:none;overflow:hidden;}

    #maAdd{overflow:hidden;margin-top:20px;}
    #maAdd button{}

    #maTable{margin-top:20px;margin-left:0px;margin-right:0px;}

    #maPage{overflow:hidden;background:none;margin-top:10px;}
      #maPage div{float:right;margin-right:0px;}

    
</style>

<script>
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  // import {CodeToText, regionDataPlus} from 'element-china-area-data'
  export default{
    data () {
      return {
        sNum: 0,
        // options: regionDataPlus,
        sstatusAr: [
          {label: this.$t('app_allstatus'), value: ''},
          {label: this.$t('app_prePushVerify'), value: '0'},
          {label: this.$t('app_preVerify'), value: '1'},
          {label: this.$t('app_verifyPass'), value: '2'},
          {label: this.$t('app_verifyNotPass'), value: '3'}
        ],
        statusVl: '',
        mechanismId: '',
        loading: 0,
        mechanismData: '',
        queryKey: '',
        appType: '',
        tableData: [],
        multipleSelection: [],
        total: 0,
        page: 1,
        dialogTopMgVisible: 0,
        dialogConfig: {tip: '', data: '', type: ''},
        selectAll: {}
      }
    },
    components: {
      MechanismSelector
    },
    computed: {
     
    },
    methods: {
      push (row) {
        this.$setWObj('pushList', {data: row, type: '15'})
        this.$router.push({path: '/non-it-eq/src/push'})
      },
      stchange () {
        this.getList()
      },
      getStatus (value) {
        if (!value) return ''
        switch (value) {
          case '0':
            return {vl: this.$t('app_prePushVerify'), style: 'color:#8492A6;'}
          case '1':
            return {vl: this.$t('app_preVerify'), style: 'color:#F7BA2A;'}
          case '2':
            return {vl: this.$t('app_verifyPass'), style: 'color:#13CE66;'}
          case '3':
            return {vl: this.$t('app_verifyNotPass'), style: 'color:#FF4949;'}
        }
      },
      makeArea (row) {
        // if (row.address) {
        //   var arr = row.address.split(',')
        //   console.log(arr)
        //   var p = arr[0]? CodeToText[arr[0]] : ''
        //   var c = arr[1]? CodeToText[arr[1]] : ''
        //   var a = arr[2]? CodeToText[arr[2]] : ''
        //   return p+c+a
        // }
        
      },
      handleChange () {
        this.getList()
      },
      setAddr (row) {
        // var p = row.province? CodeToText[row.province] : ''
        // var c = row.city? CodeToText[row.city] : ''
        // var a = row.area? CodeToText[row.area] : ''
        // return p+c+a + row.manufacturerAddress
      },
      setInstallType (type) {
        return this.$installType[type]
      },
      query () {
        this.getList()
      },
      reset () {
        this.queryKey = ''
        this.appType = ''
        this.getList()
      },
      selectChange (vl) {
        this.getList()
      },
      cellClick (row, ev, col) {
        if (col.label && col.label !== this.$t('app_operate') ) {
          // console.log(row)
          // this.$setWObj('editAppConfig', {type: 2, data: row})
          // /appSlot/view
          //this.$router.push({name: this.$t('menu.appManageSub.viewApp')})

          // this.edit(row)
          if (row.status == 2){
            this.detail(row)
          } else {
            this.edit(row)
          }
          
        }
      },
      dateFormat (row, column) {
        // var date = row[column.property]
        // if (date === undefined) {
        //   return ''
        // }
        // return mm(date).format('YYYY-MM-DD HH:mm:ss')
      },
      pageSelect (index) {
        this.page = index
        this.getList()
      },
      pageSized (val) {
        this.$gRow = val
        this.getList()
      },
      toggleSelection (rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row)
          })
        } else {
          this.$refs.multipleTable.clearSelection()
        }
      },
      bcdel () {
        this.$showConfirm(this.$t('app_tip'), this.$t("app_tipAppEdit"), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          var ids = ''
          this.multipleSelection.forEach((vl) => {
            ids += vl.dispenserId + ','
          })
          ids = ids.substring(0, ids.length - 1)
          if (!ids) {
            this.$message(this.$t('app_chooseOneMust'))
            return
          }
          this.delRqs(ids)
        }, '')

      },
      handleSelectionChange (val) {
        this.sNum = val.length
        this.multipleSelection = val

      },
      submit (id) {
        this.$showConfirm(this.$t('app_tip'), this.$t("app_tipVerify"), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          this.loading = 1
          this.$assubmit(id, '', '1', (res) => {
            if (res.status === 200) {
              // this.$message.success(res.message)
              this.getList()
            } else {
              this.$message.error(res.message)
            }
            this.loading = 0
          }, () => {
            // error
            this.loading = 0
          })
        }, '')
      },
      del (mid) {
        this.$showConfirm(this.$t('app_tip'), this.$t("app_tipAppEdit"), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          this.delRqs(mid)
        }, '')
      },
      delRqs (mid) {
        this.loading = 1
        this.$delNonieAs(mid, (res) => {
          if (res.status === 200) {
            // this.$message.success(res.message)
            this.getList()
          } else {
            this.$message.error(res.message)
          }
          this.loading = 0
        }, () => {
          // error
          this.loading = 0
        })
      },
      detail (row) {
        // this.$setTmp('mcedit',{data: row, type: 1})
        this.$setWObj('nsObj', row)
        this.$router.push({path: '/non-it-eq/src/detail'})
      },
      edit (row) {
        this.$router.push({path: '/non-it-eq/src/edit', query:{data: row}})
      },
      add () {
        // /appSlot/distribute-add
        //this.$router.push({name: this.$t('menu.appManageSub.custom')})
        // this.$setTmp('mcedit', {type: 0, data: {}})
        this.$router.push({path: '/non-it-eq/src/add'})
      },
      bindOperate (obj) {
        //console.log(obj)
        //return
        //this.$setWObj('appBindInfo', {data: obj, type: 1})
        //this.$router.push({name: this.$t('menu.appManageSub.customPush')})
        this.$setWObj('pushList', {data: obj, type: '1'})
        this.$router.push({path: '/appslot/distribute-push'})
      },
      selected (rows) {
        /* rows.forEach(row => {
          console.log('e', row)
          this.$refs.multipleTable.toggleRowSelection(row);
        }) */
      },
      getList () {
        this.loading = 1
        var name = this.queryKey ? this.queryKey : ''
        
        var mech = this.mechanismId ? this.mechanismId: ''
        this.$getasList(this.page, this.$gRow, this.statusVl,mech, '2', name, (res) => {
          console.log(res)
          this.loading = 0
          if (res.status === 200) {
            this.total = res.total
            this.tableData = res.data
            // console.log('tbd', res.data)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
          // error
        })
        
      }
    },
    mounted () {

      var mVl = '' //默认选中
      var _this = this
      this.mechanismData = {
        value: mVl,
        placeholder: this.$t('lin_global.place_areaid'),
        optValue: true,
        callback (value) {
          _this.mechanismId = value.id
          _this.getList()
        }
      }
      
    
      
      this.getList()
      
    }
  }
</script>



// WEBPACK FOOTER //
// list.vue?5457c190